import type { StateStorage } from "zustand/middleware";

/**
 * Session storage for the form assistant: kept across a reload of this tab only.
 * Storage that is blocked or full never breaks the assistant; the state is just
 * not kept for the reload.
 */
export const tabStorage: StateStorage = {
  getItem: (name) => {
    try {
      return sessionStorage.getItem(name);
    } catch {
      return null;
    }
  },
  setItem: (name, value) => {
    try {
      sessionStorage.setItem(name, value);
    } catch {
      // Not kept for a reload.
    }
  },
  removeItem: (name) => {
    try {
      sessionStorage.removeItem(name);
    } catch {
      // Nothing was kept.
    }
  },
};

/**
 * One visit to the form builder: the router's key for this history entry, which a
 * reload keeps and every new navigation changes, so opening the same new-form
 * link again starts a new form.
 */
export function editorVisitKey(): string {
  const state = window.history.state as { __TSR_key?: string; key?: string } | null;
  return `${state?.__TSR_key ?? state?.key ?? ""}${window.location.search}`;
}
